import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BulkImportRecordsState } from './bulk-import.reducer';

export const selectDataState = createFeatureSelector<BulkImportRecordsState>('bulkImportRecords');

export const selectDataLoading = createSelector(
    selectDataState,
    (state: BulkImportRecordsState) => state.loading
);

export const selectBulkImportHistory = createSelector(
    selectDataState,
    (state: BulkImportRecordsState) => state.bulkItems
);